export default __webpack_public_path__ + "static/media/DataIntegration.977cad4a.svg";